import { render, staticRenderFns } from "./Remake.vue?vue&type=template&id=12ddfa76&scoped=true&"
import script from "./Remake.vue?vue&type=script&lang=ts&"
export * from "./Remake.vue?vue&type=script&lang=ts&"
import style0 from "./Remake.vue?vue&type=style&index=0&id=12ddfa76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ddfa76",
  null
  
)

export default component.exports